export const quickLiksMenus = [
  {
    id: 1,
    name: "User Dashboard",
    value: "user_dashboard",
  },
  {
    id: 2,
    name: "Self paced Scrum Master",
    value: "self_paced_scrum_master",
  },
  {
    id: 3,
    name: "Self paced Product Manager",
    value: "self_paced_product_manager",
  },
];
